module.exports = "/_next/static/images/sprite-icons-41a6afcd7d03dccc58126b74e588d9bc.svg";